import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiHoutenRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Houten"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={70.00}
      distance="60 km"
      duration="50-55 minuten"
    />
  );
}
